import PrenotazioniCup from "../";

const routes = [
    { name: "PrenotazioniCupList", path: "/prenotazionicup", component: PrenotazioniCup.PrenotazioniCupList, meta: { title: "Prenotazioni" } },
    // { name: "AmbulatorioView", path: "/ambulatorio/view/:id", component: Ambulatori.AmbulatorioView, meta: { title: "ambulatori.lblTitle" } },
    { name: "PrenotazioniCupEdit", path: "/prenotazionicup/edit/:id", component: PrenotazioniCup.PrenotazioniCupEdit, meta: { title: "Prenotazione" } },
];

export default routes;
